import { Injectable } from '@angular/core';
import { CryptoService } from '../../commonService/crypto.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { BehaviorSubject } from 'rxjs';
import { CookiesService } from '../../cookies.service';
import { PreviousPageCaptureService } from '../previous-page-capture.service';
import { Router } from '@angular/router';
import { PreviousPageCapturePolicyBksService } from '../previous-page-capture-policy-bks.service';

@Injectable({
  providedIn: 'root'
})
export class PolicyManagementService {

  policyListValue = new BehaviorSubject<any[]>([]);
  travelPolicyName = new BehaviorSubject(null);
  branch: any;
  dept: any;
  linkNamd: any
  routeUrl = {
    currentRoute: '',
    nextRoute: ''
  }

  // currectPageByUrl(url: any) {
  //   const uuidRegex =
  //     /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  //   const segments = url.replace(/\/+$/, '').split('/');
  //   let lastSegment = segments.pop() || '';
  //   if (uuidRegex.test(lastSegment)) {
  //     lastSegment = segments.pop() || '';
  //   }
  //   if (/^\d+$/.test(lastSegment)) {
  //     lastSegment = segments.pop() || '';
  //   }
  //   if (lastSegment.includes('type=1') || lastSegment.includes('type=2')) {
  //     lastSegment = lastSegment.split('?')[0];
  //   }
  //   return lastSegment;
  // }

  currectPageByUrl(url: any) {
  if (!url) return '';

  //  Remove query params (?) and hash (#)
  url = url.split('?')[0].split('#')[0];

  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

  const segments = url.replace(/\/+$/, '').split('/');
  let lastSegment = segments.pop() || '';

  // Remove UUID
  if (uuidRegex.test(lastSegment)) {
    lastSegment = segments.pop() || '';
  }

  // Remove numeric ID
  if (/^\d+$/.test(lastSegment)) {
    lastSegment = segments.pop() || '';
  }

  return lastSegment;
}

  constructor(private readonly navService:PreviousPageCaptureService, private readonly navServiceBks:PreviousPageCapturePolicyBksService, private _Router: Router,private crypto: CryptoService, private _CommonService: CommonService, private readonly cookiesService:CookiesService) {

  }
  // setGTM(analytics:any,scriptName:string,data:any){
  //   if(this.hasAcceptedCookies()){
  //     logEvent(analytics,scriptName, data);
  //   }
  // }
    setGTM(analytics: any, scriptName: string, data: any) {
    if (this.hasAcceptedCookies()) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(data);
    }
  }
  hasAcceptedCookies(): boolean {
    let cookie = localStorage.getItem('cookieAccepted') === 'true'?true:false;
    return cookie;
  }
  getUserRole(): string {
    const travelArranger = this.crypto.getValueFromKey('ISCORPTRAVELARRANGER') as string;
    switch (travelArranger) {
      case '0': return 'Admin';
      case '1': return 'TravelArranger';
      case '2': return 'Employee';
      default: return ''
    }
  }
  formatRouteName(route: string): string {
    return route
      .split('-')                         // ['traveler', 'management']
      .map(word =>
        word.charAt(0).toUpperCase() + word.slice(1)
      )
      .join(' ');                         // 'Traveler Management'
  }

  // currentPage(): any {
  //   const url = this.routeUrl.nextRoute;
  //   // Remove query params if they exist
  //   const cleanUrl = url.split('?')[0];
  //   // Get last route segment
  //   return cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1);
  // }
  // previousPage(): any {
  //   const url = this.routeUrl.currentRoute;
  //   // Remove query params if they exist
  //   const cleanUrl = url.split('?')[0].split('#')[0];
  //   // Get last route segment
  //   return this.formatRouteName(cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1));
  // }

  currentPage(): any {
    const url = this.currectPageByUrl(this.navService.getCurrentUrl);
    // Remove query params if they exist
    return url;
  }

  previousPage(): any {
    const url = this.currectPageByUrl(this.navService.getPreviousUrl);
    // Get last route segment
    return url;
  }

  previousPage2ndStep(): any {
    const url = this.currectPageByUrl(this.navServiceBks.getThreeStepBackUrl);
    // Get last route segment
    return url;
  }

  
  toTitleCase(text: string): string {
    return text
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  getTravelPurpose(travelCode: string): string {
    switch (travelCode) {
      case 'GTC': return 'Guest';
      case 'BTC': return 'Business Trip';
      case 'FTC': return 'Family Trip';
      default: return ''
    }
  }

  getJourneyRule(journeyRule: any): string {
    if (!journeyRule) return 'NA';

    const ruleMap: any = {
      OW: 'One Way Flight',
      RT: 'Round Trip Flight',
      MCT: 'Multi Destination Flight'
    };

    return Object.keys(journeyRule)
      .filter(key => journeyRule[key])
      .map(key => ruleMap[key])
      .join(', ');
  }


  ladingPage1() {
    try {

      const eventData = {
        'event': 'page_landing',
        'previous_screen_name': this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
       'screen_name':  this.currentPage() || 'NA', // dynamically capture the current page name/title
         'no_of_results': 'NA', // pass number of results, NA if not applicable
       'member': this.getUserRole(),   // dynamically capture ex: employee
       'action': this._CommonService.actionName,// dynamically capture the feature name
        'subaction': 'Policy Management Workflow'// dynamically  capture the POD name
      }
      this.setGTM(this.cookiesService.analytics, 'save_success', eventData);
    } catch (error) {
      //console.error('GTM - Error in save_success:', error)

    }
  }

  ladingPage(resultCount: any) {
  try {

    const eventData = {
      event: 'page_landing',
      previous_screen_name: this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
      screen_name: this.currentPage() || 'NA', // dynamically capture the current page name/title
      no_of_results: resultCount && resultCount > 0 ? resultCount : 'NA', // pass number of results, NA if not applicable
      member: this.getUserRole(), // dynamically capture ex: employee
      action: this._CommonService.actionName, // dynamically capture the feature name
      subaction: 'Policy Management Workflow' // dynamically  capture the POD name
    }

    this.setGTM(this.cookiesService.analytics, 'save_success', eventData);

  } catch (error) {}
}

page_landing(eventCategory: string, resultCount: any, subAction: string) {
    try {

      const eventData = {
        'event': 'page_landing',
        'previous_screen_name':  this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        // 'event_action': this.previousPage() || 'NA', // dynamically capture the previous tab user is on/title, if no previous page, then NA
        'screen_name':  this.currentPage() || 'NA', // dynamically capture the current page name/title
        'no_of_results': resultCount && resultCount > 0 ? resultCount : 'NA', // pass number of results, NA if not applicable
        'member': this.getUserRole(),   // dynamically capture ex: employee
        'action': this._CommonService.actionName,// dynamically capture the feature name
        'subaction': subAction// dynamically  capture the POD name
      }

      this.setGTM(this.cookiesService.analytics, 'page_landing', eventData);

    } catch (error) {
    }
  }

  save_success(eventCategory: string, linkName: string) {
    try {

      const eventData = {
       'event': 'policy_save_success',
        'screen_name': this.currentPage(), // Dynamically capture the page name
        'previous_screen_name': this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        'event_action': `${linkName} Click`, // Dynamically capture the CTA
        'link_name': 'Success', // static
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Policy Management Workflow' // dynamically capture the POD name
      }

      this.setGTM(this.cookiesService.analytics, 'policy_save_success', eventData);

    } catch (error) {

    }
  }
  policy_rule_save(formValue:any) {
    try {

      const eventData = {
       'event': 'policy_change_save',
        'screen_name': this.currentPage(), // Dynamically capture the page name
        'previous_screen_name':  this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        'event_action': 'Save Click', // Dynamically capture the CTA
        'link_name': formValue, // static
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Policy Management Workflow' // dynamically capture the POD name
      }

      this.setGTM(this.cookiesService.analytics, 'policy_save_success', eventData);

    } catch (error) {

    }
  }

  policy_rule_saveCont() {
    try {

      const eventData = {
       'event': 'policy_change_save',
        'screen_name': this.currentPage(), // Dynamically capture the page name
        'previous_screen_name':  this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        'event_action': 'Save Click', // Dynamically capture the CTA
        'link_name':'Flight Changes: Yes | Fare type for reissue: Refundable | Reissue window: 30 days', // static
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Policy Management Workflow' // dynamically capture the POD name
      }

      this.setGTM(this.cookiesService.analytics, 'policy_save_success', eventData);

    } catch (error) {

    }
  }

  view_error_message(errMsg:any,errCode:any){
    try {

      const eventData = {
       'event': 'view_error_message',
       'event_action': 'Error messages', // Static capture the CTA
        'screen_name': this.currentPage(), // Dynamically capture the page name
        'previous_screen_name':  this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        'link_name': errMsg, // static
        'error_message':errMsg,
        'error_code':errCode || '400',
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Policy Management Workflow' // dynamically capture the POD name
      }

      this.setGTM(this.cookiesService.analytics, 'view_error_message', eventData);

    } catch (error) {

    }
  }


  // policy_management(eventCategory: string, linkName: string) {
  //   try {

  //     const eventData = {
  //       'event': 'policy_menu_click',
  // 'screen_name': this.currentPage(), // Dynamically capture the tab user is on
  // 'previous_screen_name': this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
  // 'event_action': 'Menu Click', // static
  // 'link_name': eventCategory, // dynamically capture clicked CTA eg: Policy criteria, Change rules, Upgrade policy etc
  // 'member': this.getUserRole(), // dynamically capture ex: employee
  // 'action': this._CommonService.actionName, // dynamically capture the feature name
  // 'subaction': 'Policy Management Workflow' // dynamically capture the POD name
  //     }

  //     //console.log("Policy Menu link clicked", eventData);
  //     this.setGTM(this.cookiesService.analytics, 'policy_menu_click', eventData);

  //   } catch (error) {
  //     //console.error('GTM - Error in policy_management:', error)

  //   }
  // }


  policy_management() {
    try {

      const eventData = {
        'event': 'policy_menu_click',
        'screen_name': this.previousPage().replaceAll('-',' '), // Dynamically capture the tab user is on
        'previous_screen_name': this.previousPage2ndStep() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        'event_action': 'Menu Click', // static
        'link_name': this.toTitleCase((this.currectPageByUrl(
          this.navService.getCurrentUrl
        )).replaceAll('-',' ')), // dynamically capture clicked CTA eg: Policy criteria, Change rules, Upgrade policy etc
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Policy Management Workflow' // dynamically capture the POD name
      }

      //console.log("Policy Menu link clicked", eventData);
      this.setGTM(this.cookiesService.analytics, 'policy_menu_click', eventData);

    } catch (error) {
      //console.error('GTM - Error in policy_management:', error)

    }
  }

  policy_management_addNew(CTALink: string, result: number) {
    try {
      const eventData = {
        'event': CTALink=='View'?'policy_view':'policy_add',
        'screen_name': this.currentPage(), // Dynamically capture the page name
        'previous_screen_name':  this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        'event_action': `${CTALink} Click`, // Dynamically capture the CTA
        'link_name': CTALink=='View'?CTALink:'Add', // static
        'no_of_results': result, // pass number of results, NA if not applicable
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Policy Management Workflow' // dynamically capture the POD name
      }
      //console.log("Policy Management Add/View", eventData);
      this.setGTM(this.cookiesService.analytics, CTALink=='View'?'policy_view':'policy_add', eventData);

    } catch (error) {
      //console.error('GTM - Error in policy_management_addNew:', error)

    }
  }

  policy_edit_success(CtaLink: string){
    try {
      const eventData = {
        'event':'policy_edit_success',
        'screen_name': this.currentPage(), // Dynamically capture the page name
        'previous_screen_name': this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        'event_action': `${CtaLink} Click`, // Dynamically capture the CTA
        'link_name': 'Success', // Static capturethe filled information
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Policy Management Workflow' // dynamically capture the POD name
      }

      this.setGTM(this.cookiesService.analytics, 'policy_edit_success', eventData);

    } catch (error) {

    }
  }

  policy_configuration_Cancel(eventCategory: string, linkName: string) {
    try {
      const eventData = {
        'event':'policy_configuration_click',
        'screen_name': this.currentPage(), // Dynamically capture the page name
        'previous_screen_name': this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        'event_action': `${linkName} Click`, // Dynamically capture the CTA
        'link_name': linkName, // dynamically capturethe filled information
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Policy Management Workflow' // dynamically capture the POD name
      }

      this.setGTM(this.cookiesService.analytics, 'policy_configuration_click', eventData);

    } catch (error) {

    }
  }

  policy_configuration_save(eventCategory: string, CTALink: string, data: any) {
    
    try {

      const travelCat = data.list.TravelCategory.pipe.find((item: { TravelCategory_ID: number }) => item.TravelCategory_ID == data.form.policyflow.TravelCategory).TravelCategory;
      const product = data.list.GetProdectData.pipe.find((item: { Product_code: string }) => item.Product_code == data.form.policyflow.productCode).Product_Name;
      const ruleOn = data.list.GetRuleAppliesOn.pipe.find((item: { ID: number }) => item.ID == data.form.policyflow.appliedOn).Name;

      // switch(data.form.policyflow.appliedOn){
      //   case 1 :
      // }

      if (data.form.policyflow.appliedOn == 1) {
        const SelectedCorporate = data.form.policyflow.AppliedFor;
        this.branch = data.list.AssociatedWithBranch.all.filter((item: { ID: any }) => Number(SelectedCorporate.includes(item.ID)))[0].Name
        this.linkNamd = `Travel Policy: ${data.form.TravelPolicyTitle} |Travel Purpose: ${this.getTravelPurpose(data.form.TravelPurpose)} | Travel Category: ${travelCat} | Product: ${product} | Rule applied on: ${ruleOn} | Associate with Corporate: ${this.branch}`

      }

      if (data.form.policyflow.appliedOn == 2) {
        const SelectedCorporate = data.form.AssociatedWithBranchId;
        this.branch = data.list[2].all.filter((item: { ID: any }) => Number(SelectedCorporate.includes(item.ID)))
        const branchName = this.branch.map((b: { Name: string; }) => b.Name.trim()).join(',')
        this.linkNamd = `Travel Policy: ${data.form.TravelPolicyTitle} |Travel Purpose: ${this.getTravelPurpose(data.form.TravelPurpose)} | Travel Category: ${travelCat} | Product: ${product} | Rule applied on: ${ruleOn} | Associate with Branch: ${branchName}`

      }

      if (data.form.policyflow.appliedOn == 3) {
        const SelectedBranch = data.form.AssociatedWithBranchId;
        this.branch = data.list[2].all.filter((item: { ID: any }) => Number(SelectedBranch.includes(item.ID)))
        const branchName = this.branch.map((b: { Name: string; }) => b.Name.trim()).join(',')

        const SelectedDept = data.form.policyflow.AppliedFor;
        this.dept = data.list.AssociatedWithBranch.all.filter((item: { ID: any }) => SelectedDept.includes(item.ID))
        const deptName = this.dept.map((b: { Name: string; }) => b.Name.trim()).join(',')

        this.linkNamd = `Travel Policy: ${data.form.TravelPolicyTitle} |Travel Purpose: ${this.getTravelPurpose(data.form.TravelPurpose)} | Travel Category: ${travelCat} | Product: ${product} | Rule applied on: ${ruleOn} | Associate with Branch: ${branchName} | Associate with Department: ${deptName}`

      }

      if (data.form.policyflow.appliedOn == 4) {
        const SelectedBranch = data.form.AssociatedWithBranchId;
        this.branch = data.list[2].all.filter((item: { ID: any }) => Number(SelectedBranch.includes(item.ID)))
        const branchName = this.branch.map((b: { Name: string; }) => b.Name.trim()).join(',')

        const SelectedDes = data.form.policyflow.AppliedFor;
        this.dept = data.list.AssociatedWithBranch.all.filter((item: { ID: any }) => SelectedDes.includes(item.ID))
        const desName = this.dept.map((b: { name: string; }) => b.name.trim()).join(',')

        this.linkNamd = `Travel Policy: ${data.form.TravelPolicyTitle} |Travel Purpose: ${this.getTravelPurpose(data.form.TravelPurpose)} | Travel Category: ${travelCat} | Product: ${product} | Rule applied on: ${ruleOn} | Associate with Branch: ${branchName} | Associate with Designation: ${desName}`

      }

      if (data.form.policyflow.appliedOn == 5) {
        const SelectedBranch = data.form.AssociatedWithBranchId;
        this.branch = data.list[2].all.filter((item: { ID: any }) => Number(SelectedBranch.includes(item.ID)))
        const branchName = this.branch.map((b: { Name: string; }) => b.Name.trim()).join(',')

        const SelectedGrade = data.form.policyflow.AppliedFor;
        this.dept = data.list.AssociatedWithBranch.all.filter((item: { ID: any }) => SelectedGrade.includes(item.ID))
        const gradeName = this.dept.map((b: { name: string; }) => b.name.trim()).join(',')

        this.linkNamd = `Travel Policy: ${data.form.TravelPolicyTitle} |Travel Purpose: ${this.getTravelPurpose(data.form.TravelPurpose)} | Travel Category: ${travelCat} | Product: ${product} | Rule applied on: ${ruleOn} | Associate with Branch: ${branchName} | Associate with Grade: ${gradeName}`

      }

      if (data.form.policyflow.appliedOn == 6) {
        const SelectedCorporate = data.form.policyflow.AppliedFor;
        this.branch = data.list.AssociatedWithBranch.all.filter((item: { ID: any }) => Number(SelectedCorporate.includes(item.ID)))
        const travelerName = this.branch.map((b: { name: string }) => b.name.trim()).join(',')
        this.linkNamd = `Travel Policy: ${data.form.TravelPolicyTitle} |Travel Purpose: ${this.getTravelPurpose(data.form.TravelPurpose)} | Travel Category: ${travelCat} | Product: ${product} | Rule applied on: ${ruleOn} | Associate with Traveler: ${travelerName}`
      }
      const eventData = {
        'event':'policy_configuration_save',
  'screen_name': this.currentPage(), // Dynamically capture the page name
  'previous_screen_name': this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
  'event_action': `${CTALink} Click`, // Dynamically capture the CTA
  'link_name': this.linkNamd, // dynamically capture the filled information
  'member': this.getUserRole(), // dynamically capture ex: employee
  'action': this._CommonService.actionName, // dynamically capture the feature name
  'subaction': 'Policy Management Workflow' // dynamically capture the POD name
      }


      this.setGTM(this.cookiesService.analytics, 'policy_configuration_save', eventData);

    } catch (error) {

    }
  }

  policy_criteria_Cancel(eventCategory: string, linkName: string) {
    try {

      const eventData = {
        'event':'policy_criteria_click',
        'screen_name': this.currentPage(), // Dynamically capture the page name
        'previous_screen_name': this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        'event_action':`${linkName} Click`, // Dynamically capture the CTA
        'link_name': linkName, // static
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Policy Management Workflow' // dynamically capture the POD name
      }

      this.setGTM(this.cookiesService.analytics, 'policy_criteria_click', eventData);

    } catch (error) {

    }
  }

  policy_criteria_save(eventCategory: string, CTALink: string, data: any, travelPolicy: string) {

    try {

      const journeyRule = this.getJourneyRule(data?.jouneryRule);
      const marketType = data?.policyCriteria.find((item: { key: string; }) => item.key === 'Market type')?.value;
      const airline = data?.policyCriteria.find((item: { key: string; }) => item.key === 'Airline')?.value;
      const origin = data?.policyCriteria.find((item: { key: string; }) => item.key === 'Origin')?.value;

      const eventData = {
        'event':'policy_criteria_save',
        'screen_name': this.currentPage(), // Dynamically capture the page name
        'event_action': `${CTALink} Click`, // Dynamically capture the CTA
        'link_name': `Travel Policy: ${travelPolicy} | Journey Rule: ${journeyRule} | Market type: ${marketType} | Airline: ${airline} | Origin: ${origin}`, // dynamically capture the filled information
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Policy Management Workflow' // dynamically capture the POD name
      }

      this.setGTM(this.cookiesService.analytics, 'policy_criteria_save', eventData)

    } catch (error) {

    }
  }

  policy_upgrade_Cancel(eventCategory: string, linkName: string) {
    try {

      const eventData = {
        'event':'policy_upgrade_click',
        'screen_name': this.currentPage(), // Dynamically capture the page name
        'previous_screen_name':  this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        'event_action': `${linkName} Click`, // Dynamically capture the CTA
        'link_name': linkName, // static
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Policy Management Workflow' // dynamically capture the POD name
      }

      this.setGTM(this.cookiesService.analytics, 'policy_upgrade_click', eventData);

    } catch (error) {

    }
  }

  policy_upgrade_Change() {
    try {
      const eventData = {
        'event':'policy_change',
        'screen_name': this.currentPage(), // Dynamically capture the page name
        'previous_screen_name':  this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        'event_action': `Cancel Click`, // Dynamically capture the CTA
        'link_name': 'Cancel', // static
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Policy Management Workflow' // dynamically capture the POD name
      }

      this.setGTM(this.cookiesService.analytics, 'policy_upgrade_click', eventData);

    } catch (error) {

    }
  }

  policy_change_click(CTAClick:string) {
    try {
      const eventData = {
        'event':'policy_change',
        'screen_name': this.currentPage(), // Dynamically capture the page name
        'previous_screen_name': this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        'event_action': `${CTAClick} Click`, // Dynamically capture the CTA
        'link_name': 'Cancel', // static
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Policy Management Workflow' // dynamically capture the POD name
      }

      this.setGTM(this.cookiesService.analytics, 'policy_change', eventData);

    } catch (error) {

    }
  }


  policy_upgrade_save(eventCategory: string, CTALink:string) {
    // const getCrmIdValueFromKey = JSON.parse(sessionStorage.getItem('QlAccessToken') || '{}');
     const token = sessionStorage.getItem('QlAccessToken') || '';
  let decodedToken: any = {};

  if (token) {
    try {
      const payload = token.split('.')[1];
      decodedToken = JSON.parse(atob(payload));
    } catch (e) {}
  }
    try {

      const eventData = {
        'event':'policy_upgrade_save',
        'screen_name': this.currentPage(), // Dynamically capture the page name
        'previous_screen_name':  this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        'event_action': `${CTALink} Click`, // Dynamically capture the CTA
        'link_name':CTALink, // dynamically capture the filled information
        'crm_id': decodedToken?.contactId || '', // dynamically capture the CRM ID of the logged-in customer
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Policy Management Workflow' // dynamically capture the POD name
      }

      this.setGTM(this.cookiesService.analytics, 'policy_upgrade_save', eventData)

    } catch (error) {

    }
  }

  policy_management_filter(eventCategory: string, CTALink: string) {
    // const getCrmIdValueFromKey = JSON.parse(sessionStorage.getItem('QlAccessToken') || '{}');
     const token = sessionStorage.getItem('QlAccessToken') || '';
  let decodedToken: any = {};

  if (token) {
    try {
      const payload = token.split('.')[1];
      decodedToken = JSON.parse(atob(payload));
    } catch (e) {}
  }
    try {
      const eventData = {
        'event': 'policy_management_click',
        'screen_name': this.currentPage(), // Dynamically capture the page name
        'previous_screen_name':  this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        'event_action': `${CTALink} Click`, // Dynamically capture the CTA
        'link_name': CTALink, // static 
        'crm_id': decodedToken?.contactId || '', // dynamically capture the CRM ID of the logged-in customer
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Policy Management Workflow' // dynamically capture the POD name
      }

      this.setGTM(this.cookiesService.analytics, 'policy_management_click', eventData)

    } catch (error) {

    }
  }

  policy_management_sort(eventCategory: string, CTALink: string) {
    try {
      const eventData = {
        'event': 'policy_management_click',
        'screen_name': this.currentPage(), // Dynamically capture the page name
        'previous_screen_name':  this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        'event_action': `${CTALink} Click`, // Dynamically capture the CTA
        'link_name': 'sort', // static 
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Policy Management Workflow' // dynamically capture the POD name
      }

      this.setGTM(this.cookiesService.analytics, 'policy_management_click', eventData)

    } catch (error) {

    }
  }

  policy_management_filterApply(eventCategory: string, CTALink: string, filterData:any) {
    //console.log("filterData",filterData)
    try {
      const eventData = {
        'event': 'policy_management_click',
        'screen_name': this.currentPage(), // Dynamically capture the page name
        'previous_screen_name':  this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        'event_action': `${CTALink} Click`, //dynamically capture the filter applied, eg Traveler_Filter
        'link_name': CTALink, // static
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Policy Management Workflow' // dynamically capture the POD name
      }

      this.setGTM(this.cookiesService.analytics, 'policy_management_click', eventData)

    } catch (error) {

    }
  }


  policy_management_sortoptionSelect(eventCategory: string, CTALink: string) {
    try {
      const eventData = {
        'event': 'policy_management_click',
        'screen_name': this.currentPage(), // Dynamically capture the page name
        'previous_screen_name': this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        'event_action': `${CTALink} Click`, // Dynamically capture the CTA
        'link_name': `${CTALink}_Sort`, // dynamically capture the sort option, eg: Oldest_Sort 
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Policy Management Workflow' // dynamically capture the POD name
      }

      this.setGTM(this.cookiesService.analytics, 'policy_management_click', eventData)

    } catch (error) {

    }
  }

  policy_management_search(eventCategory: string, CTALink: any, count: any) {
    try {
      const eventData = {
        'event': 'policy_management_click',
        'screen_name': this.currentPage(), // Dynamically capture the page name
        'event_action': 'Search', // Dynamically capture the CTA
        'link_name': `${CTALink}_${count}`, // dynamically capture the search text along with results displayed
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Policy Management Workflow' // dynamically capture the POD name
      }

      this.setGTM(this.cookiesService.analytics, 'policy_management_click', eventData)

    } catch (error) {

    }
  }

  policy_management_editRemove(eventCategory: string, CTALink: any, LinkName:string, count: any) {
    try {
      const eventData = {
  'event': 'policy_management_click',
  'screen_name': this.currentPage(), // Dynamically capture the page name
  'previous_screen_name':  this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
  'event_action': `${CTALink} Click`, // Dynamically capture the CTA
  'link_name': LinkName, // dynamically capture CTA if applicable eg Remove
  'no_of_results': count || 'NA', // pass number of results, NA if not applicable
  'member': this.getUserRole(), // dynamically capture ex: employee
  'action': this._CommonService.actionName, // dynamically capture the feature name
  'subaction': 'Policy Management Workflow' // dynamically capture the POD name
      }

      this.setGTM(this.cookiesService.analytics, 'policy_management_click', eventData)

    } catch (error) {

    }
  }

  policy_remove_cancelProceed(linkName: string, CTALink: any) {
    try {
      const eventData = {
        'event':'policy_remove_click',
        'screen_name':'Policy Remove PopUp', // Dynamically capure the page name
        'previous_screen_name':  this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        'event_action': `${CTALink} Click`, // Dynamically capture the CTA
        'link_name': linkName, // dynamically capture CTA if applicable eg Cancel
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Policy Management Workflow' // dynamically capture the POD name
      }

      this.setGTM(this.cookiesService.analytics, 'policy_remove_click', eventData)

    } catch (error) {

    }

  }

  policy_remove_success(eventCategory: string, CTALink: any) {

    try {
      const eventData = {
       'event': 'policy_remove_success',
        'screen_name': 'Policy Removal popUp', // Dynamically capture the page name
        'previous_screen_name': this.previousPage() || 'NA', // dynamically capture the previous page name/title, if no previous page, then NA
        'event_action': `${CTALink} Click`, // Dynamically capture the CTA
        'link_name': 'Success', // static
        'member': this.getUserRole(), // dynamically capture ex: employee
        'action': this._CommonService.actionName, // dynamically capture the feature name
        'subaction': 'Policy Management Workflow' // dynamically capture the POD name
      }

      this.setGTM(this.cookiesService.analytics, 'policy_remove_success', eventData)

    } catch (error) {

    }

  }


}
